import Image from "next/image"
import { useAppDispatch } from "integrations/redux/hooks"
import { useEffect } from "react"
import { disconnectSocket } from "features/pubsub/slice"
import { useTranslation } from "react-i18next"
import { ReturnToWorkspaceButton } from "themes/default-tailwind/buttons/ReturnToWorkspaceButton"

export default function Page500() {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        dispatch(disconnectSocket())
    }, [dispatch])
    return (
        <div className="nova-center-screen-container">
            <div className="nova-error-container flex flex-col items-center">
                <Image
                    src="/images/logos/nova-logo-with-title.svg"
                    width={150}
                    height={0}
                    alt="Nova"
                    priority={true}
                />
                <h1 className="nova-error-header">{t("Something went wrong.")}</h1>
                <h5 className="max-w-[34rem] mb-4 text-gray-100">
                    {t("We've been notified of the problem and are resolving this.")}
                </h5>
                <h5 className="mb-5 text-gray-100" style={{ width: "270px" }}>
                    {t("If you require immediate assistance, please email us at ")}
                    <a href="mailto:support@mapnova.com" className="text-blue-500">
                        {t("support@mapnova.com")}
                    </a>
                </h5>

                <ReturnToWorkspaceButton />
            </div>
        </div>
    )
}
